import { getExperimentationSettingsQuery } from '@gonfalon/rest-api/queries/experiments';
import { useQuery } from '@tanstack/react-query';

export const useProjectExperimentationSettings = ({ projectKey, enabled }: { projectKey: string; enabled?: boolean }) =>
  useQuery({
    ...getExperimentationSettingsQuery({ projectKey }),
    enabled,
  });
